import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChannelGlobal = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 20",
	fill: "currentColor",
	stroke: "#2E2E2E",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			r: 4,
			cx: 5,
			cy: 5
		}),
		/* @__PURE__ */ _jsx("circle", {
			r: 4,
			cx: 5,
			cy: 15
		}),
		/* @__PURE__ */ _jsx("circle", {
			r: 4,
			cx: 15,
			cy: 15
		}),
		/* @__PURE__ */ _jsx("circle", {
			r: 4,
			cx: 15,
			cy: 5
		})
	]
});
export default SvgChannelGlobal;
